var map = {
	"./olivine1.png": 5624,
	"./olivine10.png": 7761,
	"./olivine11.png": 970,
	"./olivine12.png": 1746,
	"./olivine13.png": 9566,
	"./olivine14.png": 9267,
	"./olivine15.png": 5332,
	"./olivine16.png": 8847,
	"./olivine17.png": 9260,
	"./olivine18.png": 7476,
	"./olivine19.png": 5796,
	"./olivine2.png": 5468,
	"./olivine20.png": 757,
	"./olivine21.png": 7615,
	"./olivine22.png": 8379,
	"./olivine23.png": 4977,
	"./olivine24.png": 3682,
	"./olivine25.png": 5713,
	"./olivine26.png": 2735,
	"./olivine27.png": 3936,
	"./olivine28.png": 9312,
	"./olivine29.png": 1339,
	"./olivine3.png": 8768,
	"./olivine30.png": 5319,
	"./olivine31.png": 722,
	"./olivine32.png": 4935,
	"./olivine33.png": 2480,
	"./olivine34.png": 6525,
	"./olivine35.png": 5297,
	"./olivine36.png": 3523,
	"./olivine37.png": 3738,
	"./olivine38.png": 6240,
	"./olivine39.png": 1722,
	"./olivine4.png": 9275,
	"./olivine40.png": 4669,
	"./olivine41.png": 5898,
	"./olivine42.png": 5442,
	"./olivine43.png": 9765,
	"./olivine44.png": 2143,
	"./olivine45.png": 1663,
	"./olivine46.png": 656,
	"./olivine47.png": 9428,
	"./olivine48.png": 3343,
	"./olivine49.png": 5931,
	"./olivine5.png": 2056,
	"./olivine50.png": 6941,
	"./olivine51.png": 8876,
	"./olivine52.png": 9018,
	"./olivine53.png": 6405,
	"./olivine54.png": 4058,
	"./olivine55.png": 1610,
	"./olivine56.png": 1987,
	"./olivine6.png": 4599,
	"./olivine7.png": 6788,
	"./olivine8.png": 4727,
	"./olivine9.png": 3978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7086;